import React from 'react';

/**
 * NightAmbience - Exact background from nimny.app
 * 
 * Uses the same:
 * - Base gradient color
 * - Star density
 * - Star size distribution
 * - Opacity values
 * - Positioning logic
 * 
 * No animations, no sparkle scaling, no pulsing effects
 */

const NightAmbience = () => {
  return (
    <>
      {/* Exact CSS from nimny.app */}
      <style>{`
        .night-sky-gradient {
          background: linear-gradient(180deg, #0d0d1c, #1a1a2e 40%, #1b1726 70%, #171221);
          inset: 0;
          pointer-events: none;
          position: fixed;
          z-index: -2;
        }
        
        .night-sky-stars-1 {
          background-image: radial-gradient(1px 1px at 2% 3%, #fff6, #0000),
            radial-gradient(1px 1px at 5% 8%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 7% 15%, #ffffff80, #0000),
            radial-gradient(1px 1px at 3% 22%, #ffffff40, #0000),
            radial-gradient(1px 1px at 9% 28%, #ffffff59, #0000),
            radial-gradient(1px 1px at 4% 35%, #ffffff73, #0000),
            radial-gradient(1px 1px at 11% 42%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 6% 48%, #fff6, #0000),
            radial-gradient(1px 1px at 8% 55%, #ffffff40, #0000),
            radial-gradient(1px 1px at 2% 62%, #ffffff80, #0000),
            radial-gradient(1px 1px at 10% 68%, #ffffff59, #0000),
            radial-gradient(1px 1px at 5% 75%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 12% 82%, #ffffff73, #0000),
            radial-gradient(1px 1px at 3% 88%, #ffffff40, #0000),
            radial-gradient(1px 1px at 7% 95%, #fff6, #0000),
            radial-gradient(1px 1px at 15% 5%, #ffffff59, #0000),
            radial-gradient(1px 1px at 18% 12%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 14% 20%, #ffffff80, #0000),
            radial-gradient(1px 1px at 20% 27%, #ffffff40, #0000),
            radial-gradient(1px 1px at 16% 35%, #fff6, #0000),
            radial-gradient(1px 1px at 22% 42%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 17% 50%, #ffffff73, #0000),
            radial-gradient(1px 1px at 19% 58%, #ffffff40, #0000),
            radial-gradient(1px 1px at 13% 65%, #ffffff59, #0000),
            radial-gradient(1px 1px at 21% 72%, #ffffff80, #0000),
            radial-gradient(1px 1px at 15% 80%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 23% 87%, #fff6, #0000),
            radial-gradient(1px 1px at 18% 93%, #ffffff40, #0000),
            radial-gradient(1px 1px at 25% 4%, #ffffff73, #0000),
            radial-gradient(1px 1px at 28% 11%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 24% 18%, #ffffff59, #0000),
            radial-gradient(1px 1px at 30% 25%, #ffffff80, #0000),
            radial-gradient(1px 1px at 26% 33%, #ffffff40, #0000),
            radial-gradient(1px 1px at 32% 40%, #fff6, #0000),
            radial-gradient(1px 1px at 27% 48%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 29% 55%, #ffffff73, #0000),
            radial-gradient(1px 1px at 33% 63%, #ffffff40, #0000),
            radial-gradient(1px 1px at 25% 70%, #ffffff59, #0000),
            radial-gradient(1px 1px at 31% 78%, #ffffff80, #0000),
            radial-gradient(1px 1px at 28% 85%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 34% 92%, #fff6, #0000),
            radial-gradient(1px 1px at 36% 6%, #ffffff40, #0000),
            radial-gradient(1px 1px at 38% 13%, #ffffff73, #0000),
            radial-gradient(1px 1px at 35% 21%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 40% 28%, #ffffff59, #0000),
            radial-gradient(1px 1px at 37% 36%, #ffffff80, #0000),
            radial-gradient(1px 1px at 42% 43%, #ffffff40, #0000),
            radial-gradient(1px 1px at 39% 51%, #fff6, #0000),
            radial-gradient(1px 1px at 41% 58%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 43% 66%, #ffffff73, #0000),
            radial-gradient(1px 1px at 36% 73%, #ffffff40, #0000),
            radial-gradient(1px 1px at 44% 81%, #ffffff59, #0000),
            radial-gradient(1px 1px at 38% 88%, #ffffff80, #0000),
            radial-gradient(1px 1px at 45% 95%, #ffffff4d, #0000);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          inset: 0;
          pointer-events: none;
          position: fixed;
          z-index: -1;
        }
        
        .night-sky-stars-2 {
          background-image: radial-gradient(1px 1px at 47% 2%, #ffffff59, #0000),
            radial-gradient(1px 1px at 50% 9%, #ffffff73, #0000),
            radial-gradient(1px 1px at 48% 17%, #ffffff40, #0000),
            radial-gradient(1px 1px at 52% 24%, #fff6, #0000),
            radial-gradient(1px 1px at 46% 32%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 54% 39%, #ffffff80, #0000),
            radial-gradient(1px 1px at 49% 47%, #ffffff40, #0000),
            radial-gradient(1px 1px at 51% 54%, #ffffff59, #0000),
            radial-gradient(1px 1px at 55% 62%, #ffffff73, #0000),
            radial-gradient(1px 1px at 47% 69%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 53% 77%, #fff6, #0000),
            radial-gradient(1px 1px at 50% 84%, #ffffff40, #0000),
            radial-gradient(1px 1px at 56% 91%, #ffffff80, #0000),
            radial-gradient(1px 1px at 58% 5%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 60% 12%, #ffffff59, #0000),
            radial-gradient(1px 1px at 57% 20%, #ffffff73, #0000),
            radial-gradient(1px 1px at 62% 27%, #ffffff40, #0000),
            radial-gradient(1px 1px at 59% 35%, #fff6, #0000),
            radial-gradient(1px 1px at 63% 42%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 61% 50%, #ffffff80, #0000),
            radial-gradient(1px 1px at 64% 57%, #ffffff40, #0000),
            radial-gradient(1px 1px at 58% 65%, #ffffff59, #0000),
            radial-gradient(1px 1px at 65% 72%, #ffffff73, #0000),
            radial-gradient(1px 1px at 60% 80%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 66% 87%, #fff6, #0000),
            radial-gradient(1px 1px at 62% 94%, #ffffff40, #0000),
            radial-gradient(1px 1px at 68% 7%, #ffffff80, #0000),
            radial-gradient(1px 1px at 70% 14%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 67% 22%, #ffffff59, #0000),
            radial-gradient(1px 1px at 72% 29%, #ffffff73, #0000),
            radial-gradient(1px 1px at 69% 37%, #ffffff40, #0000),
            radial-gradient(1px 1px at 73% 44%, #fff6, #0000),
            radial-gradient(1px 1px at 71% 52%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 74% 59%, #ffffff80, #0000),
            radial-gradient(1px 1px at 68% 67%, #ffffff40, #0000),
            radial-gradient(1px 1px at 75% 74%, #ffffff59, #0000),
            radial-gradient(1px 1px at 70% 82%, #ffffff73, #0000),
            radial-gradient(1px 1px at 76% 89%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 72% 96%, #fff6, #0000),
            radial-gradient(1px 1px at 78% 4%, #ffffff40, #0000),
            radial-gradient(1px 1px at 80% 11%, #ffffff80, #0000),
            radial-gradient(1px 1px at 77% 19%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 82% 26%, #ffffff59, #0000),
            radial-gradient(1px 1px at 79% 34%, #ffffff73, #0000),
            radial-gradient(1px 1px at 83% 41%, #ffffff40, #0000),
            radial-gradient(1px 1px at 81% 49%, #fff6, #0000),
            radial-gradient(1px 1px at 84% 56%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 78% 64%, #ffffff80, #0000),
            radial-gradient(1px 1px at 85% 71%, #ffffff40, #0000),
            radial-gradient(1px 1px at 80% 79%, #ffffff59, #0000),
            radial-gradient(1px 1px at 86% 86%, #ffffff73, #0000),
            radial-gradient(1px 1px at 82% 93%, #ffffff4d, #0000);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          inset: 0;
          pointer-events: none;
          position: fixed;
          z-index: -1;
        }
        
        .night-sky-stars-3 {
          background-image: radial-gradient(1px 1px at 88% 8%, #fff6, #0000),
            radial-gradient(1px 1px at 90% 16%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 87% 23%, #ffffff80, #0000),
            radial-gradient(1px 1px at 92% 31%, #ffffff40, #0000),
            radial-gradient(1px 1px at 89% 38%, #ffffff59, #0000),
            radial-gradient(1px 1px at 93% 46%, #ffffff73, #0000),
            radial-gradient(1px 1px at 91% 53%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 94% 61%, #fff6, #0000),
            radial-gradient(1px 1px at 88% 68%, #ffffff40, #0000),
            radial-gradient(1px 1px at 95% 76%, #ffffff80, #0000),
            radial-gradient(1px 1px at 90% 83%, #ffffff59, #0000),
            radial-gradient(1px 1px at 96% 91%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 92% 98%, #ffffff73, #0000),
            radial-gradient(1px 1px at 97% 3%, #ffffff40, #0000),
            radial-gradient(1px 1px at 98% 18%, #fff6, #0000),
            radial-gradient(1px 1px at 99% 33%, #ffffff4d, #0000),
            radial-gradient(1px 1px at 97% 48%, #ffffff80, #0000),
            radial-gradient(1px 1px at 98% 63%, #ffffff40, #0000),
            radial-gradient(1px 1px at 99% 78%, #ffffff59, #0000),
            radial-gradient(1px 1px at 96% 93%, #ffffff73, #0000),
            radial-gradient(2px 2px at 12% 45%, #ffffff59, #0000),
            radial-gradient(2px 2px at 35% 18%, #ffffff4d, #0000),
            radial-gradient(2px 2px at 58% 72%, #fff6, #0000),
            radial-gradient(2px 2px at 78% 38%, #ffffff40, #0000),
            radial-gradient(2px 2px at 45% 85%, #ffffff59, #0000),
            radial-gradient(2px 2px at 22% 62%, #ffffff4d, #0000),
            radial-gradient(2px 2px at 85% 15%, #fff6, #0000),
            radial-gradient(2px 2px at 65% 52%, #ffffff40, #0000);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          inset: 0;
          pointer-events: none;
          position: fixed;
          z-index: -1;
        }
      `}</style>

      {/* Render the background layers - exact structure from nimny.app */}
      <div className="night-sky-gradient" aria-hidden="true" />
      <div className="night-sky-stars-1" aria-hidden="true" />
      <div className="night-sky-stars-2" aria-hidden="true" />
      <div className="night-sky-stars-3" aria-hidden="true" />
    </>
  );
};

export default NightAmbience;
